import type { CSSProperties } from 'react';
import './pause_screen.css';
import { containFitScale } from '../../../infrastructure/runtime';
import { useAppFit } from '../../hooks/useAppFit';
import { ScreenHeader } from '../components/atomic/layout/screen_header/ScreenHeader';
import type { ScreenViewProps } from '../shared/screenViewProps';
import { BlurBackground } from './blur_background/BlurBackground';
import { ContinueButton } from './continue_button/ContinueButton';
import { GoHomeButton } from './go_home_button/GoHomeButton';
import { MuteToggleButton } from './mute_toggle/MuteToggleButton';
import { PlaqueFrame } from './plaque_frame/PlaqueFrame';
import { HeaderText } from './texts/HeaderText';
import type { PauseScreenController } from './PauseScreenController';
import type { PauseScreenModel } from './PauseScreenModelScreen';

export type PauseScreenViewProps = ScreenViewProps<
  PauseScreenModel,
  PauseScreenController
>;

/** Pause modal stub. */
export function PauseScreenView({ model, controller }: PauseScreenViewProps) {
  const fit = useAppFit();
  const contain = containFitScale(fit.scale);

  return (
    <>
      <BlurBackground />
      <div
        className="pause-screen"
        style={
          {
            '--fit-contain-inv-x': String(contain.invX),
            '--fit-contain-inv-y': String(contain.invY),
            '--fit-contain-uniform': String(contain.uniform),
          } as CSSProperties
        }
      >
        <div className="pause-screen-plaques">
          <ScreenHeader showSubHeader={false} />
          <HeaderText />
          <PlaqueFrame />
          <MuteToggleButton
            level={model.audioLevel}
            onClick={controller.handleCycleAudioLevel}
          />
          <ContinueButton onClick={controller.handleContinue} />
          <GoHomeButton onClick={controller.handleGoHome} />
        </div>
      </div>
    </>
  );
}
